<template>
    <section class="col s12">
        <div class="row">
            <div class="col s12 m6">
                <div class="card grey lighten-3">
                    <div class="card-content">
                        <span class="card-title">Legenda de cores das bordas dos campos</span>
                        <ul class="lista-legenda">
                            <li>
                                <span class="dot red"></span>&nbsp;<span>Campos marcados como em pendência para correção na análise técnica.</span>
                            </li>
                            <li>
                                <span class="dot indigo accent-1"></span>&nbsp;<span>Campos com o resultado da análise técnica.</span>
                            </li>
                            <li>
                                <span class="dot cyan accent-4"></span>&nbsp;<span>Campos com o resultado dos avaliadores.</span>
                            </li>
                            <li>
                                <span class="dot white"></span>&nbsp;<span>Campos normais preenchidos pelo coordenador da inscrição.</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "quadro_legendas"
}
</script>

<style scoped>


.lista-legenda li {
    display: flex;
    align-items: center;
    margin: 1px 1px 1px 1px;
    padding: 2px 2px 2px 2px;
}


</style>